// 验证正整数
const positiveIntReg = /^[1-9]\d*$/;

 // 验证是否大于等于0的整数
 export function isInteger(rule, value, callback) {
    if(rule.required){
        if(value === ""){
          return callback(new Error('请输入大于等于0的整数'));
        }
    }
    if(value === "0" || value === 0){
        return callback();
    }
    if (!Number(value)) {
        callback(new Error('请输入大于等于0的整数'));
    } else if (!positiveIntReg.test(value)) {
        callback(new Error('请输入大于等于0的整数'));
    } else {
        callback();
    }
 }

 //验证是否是大于0的整数
 export function isPositiveInteger(rule, value, callback) {
    if(rule.required){
        if(value === ""){
          return callback(new Error('请输入大于0的整数'));
        }
    }
    if(value === "0" || value === 0){
        return callback(new Error('请输入大于0的整数'));
    }
    if (!Number(value)) {
        callback(new Error('请输入大于0的整数'));
    } else if (!re.test(value)) {
        callback(new Error('请输入大于0的整数'));
    } else {
        callback();
    }
 }
 
  
  
 // 请输入0~1之间的小数
 export function isRate(rule, value, callback) {
    if(rule.required){
        if(value === ""){
          return callback(new Error('请输入0~1之间的小数'));
        }
    }
    if (!Number(value)) {
        callback(new Error('请输入0~1之间的小数'));
    } else if (value < 0 || value > 1) {
        callback(new Error('请输入0~1之间的小数'));
    } else {
        callback();
    }
 }

 const regx = "^((-?\\d+.?\\d*)[Ee]{1}(-?\\d+))$";
 export function isScientificNumber(rule, value, callback) {
    if(rule.required){
        if(value === ""){
          return callback(new Error('不能为空'));
        }
    }
    setTimeout(() => {
        var re = new RegExp(regx);
        if (re.test(value)) {
            callback();
        }else{
            callback(new Error('请输入科学计数法如 1e18'));
        }
    }, 500);
 }

// 验证是否是大于等于0的数字
export function isNumber(rule, value, callback) {
   if(rule.required){
       if(value ===""){
         return callback(new Error('请输入大于等于0的数字'));
       }
   }
   let numval =  Number(value);
   if (!numval) {
       callback(new Error('请输入大于等于0的数字'));
   } else if(numval<0){
       callback(new Error('请输入大于等于0的数字'));
   }else{
        callback();
   }
}

// 验证是否是大于零的数字
export function isPositiveNumber(rule, value, callback) {
    if(rule.required){
        if(value === ""){
          return callback(new Error('请输入大于0的数字'));
        }
    }
    let numval =  Number(value);
    if (!numval) {
        callback(new Error('请输入大于0的数字'));
    } else if(numval<=0){
        callback(new Error('请输入大于0的数字'));
    }else{
         callback();
    }
 }

 //验证手机号码
 export function isPhoneNo(rule, value, callback) {
    if(rule.required){
        if(value ==""){
          callback(new Error('不能为空'));
        }
    }
    var reg = /^1[3456789]\d{9}$/;
    if (!reg.test(value)) {
         callback(new Error('请输入正确的手机号码'));
    }else{
        callback();
    }
 }
 //验证密码
 export function checkPwd(rule,value,callback){
    if(!value || value.trim() == ""){
        callback(new Error('不能为空'));
        return;
    }
    let reg = /^[a-zA-Z0-9]{6,20}$/;
    if (!reg.test(value)) {
        callback(new Error('6~20位任意數字、字母組合'));
    }else{
        callback();
    }
}